import React from "react";
import MultiLocationModule from "./multiLocationModule";
import ErrorBoundary from "../../../../components/errorBoundary/errorBoundary";
import { Provider } from "react-redux";
import { createReduxStore } from "./redux/store";

class MultiLocation extends React.Component {
  render() {
    return (
      <Provider store={createReduxStore("multiLocation")}>
        <ErrorBoundary moduleName="multiLocation" {...this.props.notifications}>
          <MultiLocationModule userParams={this.props} />
        </ErrorBoundary>
      </Provider>
    );
  }
}

export default MultiLocation;
